import "./style.css";
import { motion } from "framer-motion";
import { Button, Col, Divider, Row, Space } from "antd";
import { ProjectData } from "../constant/project";
import { useStaggerReveal } from "../animation/scrollReveal";

const Project = ({ showModal }) => {
  const containerRef = useStaggerReveal(".project-reveal-item", { from: { opacity: 0, y: 90 }, stagger: 0.15 });
  return (
    <>
      <motion.div
        style={{
          textAlign: "center",
        }}
        className="header"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <i className="fa fa-diagram-project title-icon" />
        PROJECTS
      </motion.div>
      <Row gutter={[32, 32]} justify="center" align="stretch" style={{
        margin: 0, marginTop: 30
      }} ref={containerRef}>
        {ProjectData.map((v, k) => (
          <Col xs={24} sm={24} md={12} lg={12} xl={8} key={k} style={{ display: "flex" }} className="project-reveal-item">
            <motion.div
              id={k}
              whileHover={{
                scale: 1.02,
                y: -5,
              }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              style={{
                borderRadius: "var(--radius)",
                cursor: "pointer",
                width: "100%",
                display: "flex",
              }}
              className="page"
            >
              <div
                style={{
                  background: "#ffffff",
                  width: "100%",
                  border: v.featured ? "2px solid var(--accent-color)" : "1px solid var(--card-border)",
                  borderRadius: "var(--radius)",
                  padding: 24,
                  transition: "all 0.2s ease-in-out",
                  boxShadow: v.featured ? "12px 12px 0px var(--accent-color)" : "8px 8px 0px var(--bg-dark)",
                  position: "relative",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column"
                }}
                className="project-card"
              >
                {v.featured && (
                  <div style={{
                    position: "absolute",
                    top: 15,
                    right: -35,
                    background: "var(--accent-color)",
                    color: "white",
                    padding: "5px 40px",
                    transform: "rotate(45deg)",
                    fontSize: "12px",
                    fontWeight: "bold",
                    zIndex: 10
                  }}>FEATURED</div>
                )}
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "6px",
                  background: v.featured ? "var(--accent-color)" : "var(--bg-dark)",
                }} />
                <img
                  src={v.imgURL}
                  alt="thumbnail"
                  style={{
                    width: "100%",
                    maxHeight: 200,
                    border: "2px solid var(--bg-dark)",
                    borderRadius: "0px",
                    objectFit: "cover",
                  }}
                  className="project-thumbnail"
                />

                <div style={{ marginTop: "20px", flex: 1 }}>
                  <div className="title" style={{
                    color: "var(--text-primary)",
                    fontSize: "1.2rem",
                    fontWeight: 800,
                    marginBottom: "8px"
                  }}>{v.title}</div>

                  {v.role && (
                    <div style={{ fontSize: "12px", color: "var(--accent-color)", fontWeight: "bold", marginBottom: "10px", textTransform: "uppercase" }}>
                      Role: {v.role}
                    </div>
                  )}

                  <div style={{ marginBottom: "15px" }}>
                    <div style={{ fontSize: "13px", fontWeight: "bold", color: "var(--bg-dark)" }}>PROBLEM:</div>
                    <div style={{ fontSize: "14px", color: "var(--text-secondary)" }}>{v.problem || v.description}</div>
                  </div>

                  {v.keyFeatures && (
                    <div style={{ marginBottom: "15px" }}>
                      <div style={{ fontSize: "13px", fontWeight: "bold", color: "var(--bg-dark)" }}>KEY FEATURES:</div>
                      <ul style={{ paddingLeft: "18px", marginTop: "5px", fontSize: "14px", color: "var(--text-secondary)" }}>
                        {v.keyFeatures.map((feature, i) => (
                          <li key={i}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {v.metrics && (
                    <div style={{ background: "var(--highlight-color)", padding: "10px", borderLeft: "4px solid var(--accent-color)", marginBottom: "15px" }}>
                      <div style={{ fontSize: "11px", fontWeight: "bold", color: "var(--accent-color)" }}>BUSINESS IMPACT / METRICS:</div>
                      <div style={{ fontSize: "14px", fontWeight: "500" }}>{v.metrics}</div>
                    </div>
                  )}

                  {v.projectURL && (
                    <div style={{ marginTop: "Auto" }}>
                      <a href={v.projectURL} target="_blank" rel="noreferrer" style={{
                        color: "var(--primary-color)",
                        fontSize: "14px",
                        fontWeight: "600",
                        textDecoration: "underline"
                      }}>
                        View Live Project →
                      </a>
                    </div>
                  )}
                </div>

                <Divider style={{ margin: "15px 0", marginTop: "auto" }} />

                <LanguageBar
                  language={v.languages}
                  showModal={(e) => showModal(k)}
                  screen={v.screen}
                />
              </div>
            </motion.div>
          </Col>
        ))}
      </Row >
    </>
  );
};
export default Project;

const LanguageBar = ({ screen, language, showModal }) => {
  return (
    <Row justify={"space-between"} style={{ marginTop: 20 }}>
      {screen ? (
        <Button className="btn-primary" onClick={() => showModal()}>
          <span>Preview</span>
        </Button>
      ) : (
        <div style={{ lineHeight: 2, color: "yellow" }}>
          {/* <span>Preview unavailable</span> */}
        </div>
      )}
      <Space>
        {language.map((v, k) => (
          <div
            key={k}
            style={{
              float: "right",
              width: 20,
              height: 20,
              borderRadius: "100%",
              background: "white",
              textAlign: "center",
              // padding: 5,
            }}
            title={v}
          >
            <img src={`./icon/${v}.png`} style={{ width: "100%" }} alt="skill-icon" />
          </div>
        ))}
      </Space>
    </Row>
  );
};
